import Oidc        from 'oidc-client';
import LoginConfig from '../../configs/login/Login';

const userStore = new Oidc.WebStorageStateStore({ store: window.localStorage});
let UserManagerInstance = new Oidc.UserManager({ ...LoginConfig, userStore });

export default UserManagerInstance;